<template>
    <div v-if="languages !== ''">
        <span v-for="(lang, i) in languages" :key="lang.name" class="language">
            <component
                :is="lang.url ? 'a' : 'span'"
                :href="lang.url"
                :target="lang.url ? '_blank' : null"
            >
                {{ lang.name }}{{ i < languageCount - 1 ? ',' : '' }}
            </component>
        </span>
    </div>
</template>

<script>
import { get, concat, uniq, compact, capitalize } from 'lodash';
import { mapGetters } from 'vuex';
import { getLanguageNativeName, getQlpUrl } from '@/utils/languages.js';

export default {
    name: 'Languages',
    computed: {
        ...mapGetters(['agent', 'team', 'is_pilot']),
        languages() {
            let langs = get(this.agent, 'languages', []).map((lang) => lang.languageCode);
            get(this.team, 'members', []).forEach((member) => {
                langs = concat(
                    langs,
                    get(member, 'languages', []).map((lang) => lang.languageCode),
                );
            });
            langs = uniq(langs);
            langs = compact(langs);
            const hasChinese =
                this.is_pilot &&
                (langs.includes('zh') ||
                    langs.includes('ct') ||
                    langs.includes('md') ||
                    langs.includes('sh') ||
                    langs.includes('t1'));
            return langs.map((langKey) => {
                return {
                    name: capitalize(getLanguageNativeName(langKey)),
                    url: hasChinese ? getQlpUrl(langKey) : null,
                };
            });
        },
        languageCount() {
            return this.languages ? this.languages.length : 0;
        },
    },
};
</script>
<style lang="scss" scoped></style>
